import {Alert as MuiAlert, AlertColor, AlertTitle} from '@mui/material';
import {useTranslation} from 'react-i18next';

const getTitle = (variant: AlertColor) => {
    switch (variant) {
        case 'error':
            return 'error';
        case 'success':
            return 'success';
        case 'warning':
            return 'warning';
        default:
            return '';
    }
};

type AlertProps = {
    severity: AlertColor;
    text: string;
    onClose: () => void;
    title?: string;
};

export const Alert = ({severity, text, onClose, title}: AlertProps) => {
    const {t} = useTranslation('common');
    const finalTitle = title || t(getTitle(severity));

    return (
        <MuiAlert
            severity={severity}
            onClose={onClose}
            sx={{width: '100%'}}
            style={{whiteSpace: 'pre-wrap'}}
        >
            {finalTitle && <AlertTitle>{finalTitle}</AlertTitle>}
            {text}
        </MuiAlert>
    );
};
